import React, { useEffect, useState } from 'react';
import { OnChangeValue } from 'react-select';
import { useLocation } from 'react-router-dom';
import { FormikValues, useFormik } from 'formik';
import { Col, Form, Row } from 'react-bootstrap';

import * as routes from '@routes';
import { usePageStore } from '@stores';
import { Select } from '@components';
import FiltersSubmit from '@components/AdminFiltersBox/components/FiltersSubmit';
import { InvoicesFilters } from '@types';
import classNames from 'classnames';

interface Props {
  values: InvoicesFilters;
  onSubmit: (values: InvoicesFilters) => void;
}

const paidOptions = [
  {
    value: 'true',
    label: 'Ano',
  },
  {
    value: 'false',
    label: 'Ne',
  },
];

const InvoicesDataFilters: React.FC<Props> = (props) => {
  const location = useLocation();
  const pageState = usePageStore();
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: props.values,
    onSubmit: (values) => handleSubmit(values),
  });

  useEffect(() => {
    formik.resetForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.values]);


  const handleSubmit = (values: FormikValues) => {
    const formValues = { ...values };
    Object.getOwnPropertyNames(formValues).map((prop) => {
      if (formValues[prop] === '') {
        formValues[prop] = undefined;
      }
      return prop;
    });
    formValues.page = 1;
    props.onSubmit(formValues as InvoicesFilters);
  };

  const hasFilters = (): boolean => {
    return !!location.search || !!location.search;
  };

  function handlePaid(value: OnChangeValue<unknown, boolean>) {
    const itemValue = value as { value: string; label: string } | null;
    if (itemValue?.value === 'true') {
      return formik.setFieldValue('paid', true);
    }
    if (itemValue?.value === 'false') {
      return formik.setFieldValue('paid', false);
    }
    return formik.setFieldValue('paid', '');
  }

  return (
    <Form onSubmit={(e: React.FormEvent<HTMLFormElement>) => formik.handleSubmit(e)}>
      <div className={classNames(['component-admin-filters-box'])} style={{ marginBottom: '1rem' }}>
        <div style={{ display: 'block', flex: 1, boxShadow: 'none' }}>
          <Row>
            <Col xs={12} md={6} lg={3}>
              <Form.Group>
                <Form.Label>Číslo jednací</Form.Label>
                <Form.Control
                  size="sm"
                  type="text"
                  name="auctionNumber"
                  value={formik.values.auctionNumber || ''}
                  onChange={formik.handleChange}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={6} lg={3}>
              <Form.Group>
                <Form.Label>Zaplaceno</Form.Label>
                <Select
                  isClearable={true}
                  options={paidOptions}
                  value={paidOptions.find((i) => i.value === String(formik.values.paid)) || null}
                  onChange={(val) => handlePaid(val)}
                />
              </Form.Group>
            </Col>
          </Row>
        </div>
        <FiltersSubmit
          hasFilters={hasFilters()}
          onOpenClick={undefined}

        />
      </div>
    </Form>
  );
};

export default InvoicesDataFilters;
